<template>
  <div id="authorizeUser"></div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'AuthorizeUser',
  methods: {
    ...mapActions([
      'handleAuthenticationUser'
    ])
  },
  created: function () {
    this.handleAuthenticationUser()
      .then((data) => {
        return this.$router.replace({ name: 'Dashboard' })
      })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AuthorizeUser.vue